import styled from 'styled-components';

export const PersonalDataRoot = styled.div`
	background: ${({ theme }) => theme.slideIn.background};
	border-radius: 4px;
	box-shadow: 0 2px 5px 0 rgba(32, 56, 87, 0.08);
	font-family: ${({ theme }) => theme.font};
	width: 100%;
`;

export const PersonalDataHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	padding: 12px;
`;

export const PersonalDataHeaderLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	flex: 1;
	min-width: 0;
	overflow: hidden;
`;

export const PersonalDataAvatar = styled.div`
	width: 56px;
	height: 56px;
	overflow: clip;
	flex-shrink: 0;

	> * {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export const PersonalDataUserInfo = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 2px;
	min-width: 0;

	> *:last-child {
		padding-left: 8px !important;
	}
`;

export const PersonalDataUserNameWrapper = styled.span`
	display: block;
	min-width: 0;
	width: 100%;
`;

export const PersonalDataUserName = styled.span`
	display: block;
	font-size: 18px;
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 100%;
	color: ${({ theme }) => theme.primaryTextColor};
	font-family: ${({ theme }) => theme.font};
	padding-left: 8px;
`;

export const PersonalDataEmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	margin: 0 12px;
	padding:  12px 0;
	border-top: 1px solid ${({ theme }) => theme.form.input.border};
`;

export const PersonalDataEmptyStateText = styled.span`
	font-size: 14px;
	color: ${({ theme }) => theme.primaryTextColor};
	font-family: ${({ theme }) => theme.font};
`;

export const PersonalDataListHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px 0;
`;

export const PersonalDataListHeaderTitle = styled.span`
	font-size: 16px;
	font-weight: 600;
	color: ${({ theme }) => theme.primaryTextColor};
	font-family: ${({ theme }) => theme.font};
`;

export const PersonalDataList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 0 16px 16px;
	padding-top: 12px;
`;
